import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {PageProvider} from '../_metronic/layout/core/PageProvider'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <LayoutProvider>
        <PageProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </PageProvider>
      </LayoutProvider>
    </Suspense>
  )
}

export {App}
